export const privacyPolicy = [
    {
        value: '1',
        label: 'I accept',
        option: 'A',
        instruction: '',
    },
    {
        value: '0',
        label: "I don't accept",
        option: 'B',
        instruction: '',
    },
];
